module.exports = __webpack_public_path__ + "static/media/A1-33-Symbio-Trix-cod141.bd6b8dcc.png";